import api from '../api'

const baseUrl = '/BizSchool/api/Admin'

const dadbanPackageProvider = {
  getAllPackages(params = {}) {
    return api.post(`${baseUrl}/PackageTable`, {
      params,
    })
  },

  getPackage(id) {
    return api.get(`${baseUrl}/GetPackage/${id}`)
  },

  getInputs() {
    return api.get(`${baseUrl}/PackageInput`)
  },

  addPackage(params) {
    return api.post(`${baseUrl}/Package`, params)
  },

  updatePackage(params = {}) {
    return api.put(`${baseUrl}/Package`, params)
  },

  deletePackage(params) {
    return api.delete(`${baseUrl}/Package/${params}`)
  },
  deletePackageCourse(params = {}) {
    return api.delete(`${baseUrl}/PackageCourse/${params}`)
  },

  searchPackageCourse(params) {
    return api.post(`${baseUrl}/SearchPackageCourse`, params)
  },
  addPackageCourse(params) {
    return api.post(`${baseUrl}/PackageCourse`, params)
  },
  addPackagePrerequisite(params) {
    return api.post(`${baseUrl}/PackagePrerequisite`, params)
  },

  searchPackagePrerequisite(params) {
    return api.post(`${baseUrl}/SearchPackagePrerequisite`, params)
  },

  deletePackagePrerequisite(params = {}) {
    return api.delete(`${baseUrl}/PackagePrerequisite`, { params })
  },
}

export default dadbanPackageProvider
